export const isDOMElement = (element: any) => {
    return element instanceof Element || element instanceof HTMLDocument;
};

export default isDOMElement;



// WEBPACK FOOTER //
// ./src/utils/isDOMElement.ts